/**
 * This file contains hook functions for login modules.
 */
import {Routes} from 'modules/navigation';
import {useRouter} from 'next/router';
import {useLazyPromise} from 'utils/async';
import {useConsole} from 'utils/console';
import {getCaptchaToken} from 'utils/recaptcha';
import {apiCurrentUser} from '../provider/api';
import {
	clearAuthenticationToken,
	saveAuthenticationToken,
	saveAuthenticationUsername
} from '../provider/token';
import {apiLogin} from './api';

export interface LoginForm {
	username: string;
	password: string;
	rememberMe: boolean;
}

/**
 * Login action.
 * @returns {@link Promise}
 */
export const useLogin = () => {
	const {wlog} = useConsole();
	const router = useRouter();
	const loginOperation = useLazyPromise(async (input: LoginForm) => {
		wlog.debug('Input of login form', input);
		const recaptcha: string = await getCaptchaToken('login');

		// be sure that the current authentication token is not used.
		clearAuthenticationToken();

		const {data} = await apiLogin({
			username: input.username,
			password: input.password,
			recaptcha
		});

		if (input.rememberMe) {
			saveAuthenticationUsername(input.username);
		} else {
			// prevent the necessity to check this option all the time.
			// clearAuthenticationUsername();
		}

		saveAuthenticationToken(data.auth_token);

		// retrieve the user to get the preferred language.
		const currentUser = await apiCurrentUser();

		const _home = Routes.home.build();
		router.replace(_home, _home, {
			locale: currentUser.data.profile.preferred_language ?? router.locale
		});
	});
	return {
		loginOperation
	};
};
